const UrlServer = {
	address: "https://server.bilas.id/",
	backendapi: "https://backendapi.bilas.id/",
	apiwhatsapp: "https://wa.apibilas.com/",
	sync: "https://sync.apibilas.com/",
	apilaporan: "https://laporan.apibilas.com/",
	apiorder: "https://order.apibilas.com/",
	broadcast: "https://broadcast.apibilas.com/",
	fcm: "https://fcm.googleapis.com/fcm/send",
	// address: "http://35.240.235.163:3003/",
	// socket: "http://35.240.235.163:3003",
	// address: "http://localhost:3000/", 
	localhost: "http://localhost:3006/",
	homepage: "https://official.bilas.id/",
	qris: "https://qris.apibilas.com/api/v1/",
	modul: "https://modul.apibilas.com/api/v1/"
}

export default UrlServer;
